import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedBadgeModalActive } from '../../redux/data/dataSlice';
import CopyLinkIcon from "../../assets/images/copylink.svg";
import CheckIcon from "../../assets/images/check.svg";
import FbIcon from "../../assets/images/fb.svg";
import TwitterIcon from "../../assets/images/twitter.svg";
import CloseImage from "../../assets/images/close.svg";
import PickemQualActIcon from "../../assets/images/pickem-qualifying-activity.png";
import PlayQualActIcon from "../../assets/images/play-qualifying-activity.png";
import VoteQualActIcon from "../../assets/images/vote-qualifying-activity.png";
import WatchQualActIcon from "../../assets/images/watch-qualifying-activity.png";
import BadgeModalStreak from "./badgeModalStreak";

function BadgeModal(props) {
    const dispatch = useDispatch();
    const selectedBadge = useSelector(state => state.data.selectedBadge);
    const [linkCopied, setLinkCopied] = useState(false);
    const selectedBadgeIdRef = useRef(0);
    const tabSelected = useSelector(state => state.data.tabSelected);

    // Modal Analytics
    useEffect(() => {
        if (window._satellite) {
            if (selectedBadge && selectedBadgeIdRef.current !== selectedBadge.id) {
                selectedBadgeIdRef.current = selectedBadge.id;
                let data = {
                    modalName: "nba:membership-hub:Badges-detail",
                    contentTitle: selectedBadge.title,
                    contentID: selectedBadge.id,
                    contentType: "Badge",
                };
                window._satellite.track("modal-display", data);
                console.log("window._satellite.track:modal-display:", data);
            }
        }

        const linksInModal = document.querySelectorAll(".badge-modal-content #description a");
        linksInModal.forEach(link => {
            link.setAttribute("data-track", "click");
            link.setAttribute("data-id", "nba:membership-hub:outbound:cta");
            link.setAttribute("data-type", "cta");
            link.setAttribute("data-content", link.getAttribute("name") ? link.getAttribute("name") : "");
        });

        console.log("Badge Modal: analytics added");
    }, [selectedBadge]);

    const isBadgeEarned = badge => {
        if (badge && badge.badge_extra_data && badge.badge_extra_data.unearned && badge.badge_extra_data.unearned === "1") {
            return false;
        }

        return badge && badge.state && badge.state === "EARNED";
    };

    const shareOnSocial = (e, socialType) => {
        e.preventDefault();

        const shareUrl = `${window.location.origin}/api/meta/badges/${selectedBadge.id}`;
        console.log("shareUrl:", shareUrl);

        let shareText = (selectedBadge.badge_extra_data && selectedBadge.badge_extra_data.socialshare_copy) ? selectedBadge.badge_extra_data.socialshare_copy : "";
        console.log("shareText:", shareText);

        let url = "";

        if (socialType === "copy") {
            navigator.clipboard.writeText(shareUrl);
            setLinkCopied(true);
        }
        else if (socialType === "facebook") {
            url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`;
        }
        else if (socialType === "twitter") {
            url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`;
        }

        if (url) {
            console.log("url:", url);
            let shareWidth = 520;
            let shareHeight = 570;
            let shareLeft = (window.screen.width - shareWidth) / 2;
            let shareTop = (window.screen.height - shareHeight) / 2;
            window.open(url, "_blank", `location=yes,height=${shareHeight},width=${shareWidth},left=${shareLeft},top=${shareTop},scrollbars=yes,status=yes`);
        }
    };

    const hasQualifyingActivities = selectedBadge => {
        console.log(selectedBadge.extra_data);
        return selectedBadge.extra_data.badge_play1_text ||
            selectedBadge.extra_data.badge_vote1_text ||
            selectedBadge.extra_data.badge_watch1_text ||
            selectedBadge.extra_data.badge_pickem1_text;
    };

    const renderQualifyingActivities = selectedBadge => {
        const activityTypes = ["play", "pickem", "vote", "watch"];
        let qualifyingActivities = [];

        activityTypes.forEach(type => {
            let counter = 1;
            const getIcon = () => {
                switch (type) {
                    case "play":
                        return PlayQualActIcon;
                    case "pickem":
                        return PickemQualActIcon;
                    case "vote":
                        return VoteQualActIcon;
                    case "watch":
                        return WatchQualActIcon;
                    default:
                        return PlayQualActIcon;
                }
            };

            while (selectedBadge.extra_data[`badge_${type}${counter}_text`]) {
                const getLink = () => {
                    if (selectedBadge.extra_data[`badge_${type}${counter}_url`]) {
                        if (selectedBadge.extra_data[`badge_${type}${counter}_url`].substring(0,4) === "http") {
                            return selectedBadge.extra_data[`badge_${type}${counter}_url`];
                        } else {
                            return "https://" + selectedBadge.extra_data[`badge_${type}${counter}_url`];
                        }
                    }
                    return "";
                };

                const first = qualifyingActivities.length === 0;

                qualifyingActivities.push(
                    <div className={`qualifying-activity ${first ? "first" : ""}`}>
                        <div className="qualifying-activity-content">
                            <div className="activity-img">
                                { getLink() === "" ?
                                    <img src={getIcon()} alt="Qualifying Activity Icon" />
                                    :
                                    <a href={getLink()} target="_blank" rel="noopener noreferrer" data-track="click" data-type="cta"
                                        data-id="nba:membership-hub:outbound:cta" data-content={`${selectedBadge.title} Qualifying Activity`}>
                                        <img src={getIcon()} alt="Qualifying Activity Icon" />
                                    </a>
                                }
                            </div>
                            <div className="activity-desc">
                                <div className="activity-text"
                                dangerouslySetInnerHTML={{ __html: (selectedBadge.extra_data[`badge_${type}${counter}_text`])}}
                                ></div>
                                <a className="activity-cta" href={getLink()} target="_blank" rel="noopener noreferrer">
                                    {selectedBadge.extra_data[`badge_${type}${counter}_cta`]}
                                </a>
                            </div>
                        </div>
                    </div>
                );
                counter++;
            }
        });

        return qualifyingActivities;
    };

    return (
        <div className="modal-container">
            <div className="badge-modal">
                {props.overview ?
                    <button onClick={() => {
                        props.closeModal();
                    }}>
                        <img
                            alt="close"
                            className="flex-grow-0 flex-shrink-0 cursor-pointer"
                            style={{
                                width: "32px",
                                height: "32px",
                                float: "right",
                                margin: "15px",
                            }}
                            src={CloseImage}
                        />
                    </button>
                    :
                    <Link
                        to={{
                            pathname: `/${tabSelected}`,
                            search: window.location.search.includes("cl=1") ? window.location.search.replace("&cl=1", "") : window.location.search
                        }}
                        data-track="click"
                        data-id="nba:membership-hub:dismiss"
                        data-section="badges"
                        data-type="dismiss"
                        onClick={() => dispatch(setSelectedBadgeModalActive(false))}>
                        <img
                            alt="close"
                            className="flex-grow-0 flex-shrink-0 cursor-pointer"
                            style={{
                                width: "32px",
                                height: "32px",
                                float: "right",
                                margin: "15px",
                            }}
                            src={CloseImage}
                        />
                    </Link>
                }
                <div className="badge-modal-wrapper">
                    <div className="badge-modal-content">
                        {selectedBadge.streak && selectedBadge.streak.badge_count > 1 &&
                            <div className="count">
                                {`${selectedBadge.streak.badge_count}x`}
                            </div>
                        }
                        <img className="badge-modal-img" alt="Badges" style={{ opacity: isBadgeEarned(selectedBadge) ? 1 : 0.4 }}
                            src={selectedBadge && selectedBadge.image_url ? selectedBadge.image_url : selectedBadge.image}
                        />
                        <p className="badge-modal-header">
                            {selectedBadge && selectedBadge.title}
                        </p>
                        <p
                            id="description"
                            className="badge-modal-description"
                            dangerouslySetInnerHTML={{ __html: (selectedBadge && selectedBadge.description ? selectedBadge.description : "")}}>
                        </p>

                        {selectedBadge.streak && selectedBadge.streak.streak_count &&
                            selectedBadge.streak.streak_count > selectedBadge.streak.earned_count &&
                            <div className="badge-modal-streak">
                                <BadgeModalStreak badge={selectedBadge} />
                                {selectedBadge.streak.length !== "challenge" &&
                                    <p className="badge-modal-streak-before-date">
                                        You have until
                                        <span style={{ fontWeight: "900", color: "#4E525C" }}>
                                            {` ${new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(selectedBadge.streak.end_date * 1000)}, 
                                        ${new Intl.DateTimeFormat("en-US", { month: "long" }).format(selectedBadge.streak.end_date * 1000)} 
                                        ${(new Date(selectedBadge.streak.end_date * 1000)).getDate()} `}
                                        </span>
                                        {`to complete this ${selectedBadge.streak.length}'s streak. Keep it up!`}
                                    </p>
                                }
                            </div>
                        }

                        {selectedBadge.is_locked && hasQualifyingActivities(selectedBadge) &&
                            <div id="badge-modal-qualifying-activities">
                                {renderQualifyingActivities(selectedBadge)}
                            </div>
                        }

                        {!selectedBadge.is_locked && selectedBadge.streak && selectedBadge.streak.earned_count >= selectedBadge.streak.streak_count && isBadgeEarned(selectedBadge) &&
                            <div className="badge-modal-streak">
                                <BadgeModalStreak badge={selectedBadge} />
                                {selectedBadge.streak.length !== "challenge" &&
                                    <div className="badge-modal-congrats">
                                        {`You earned this ${selectedBadge.streak.length}'s badge.
                                        You can start working to earn next ${selectedBadge.streak.length}’s badge on `}
                                        <span style={{ fontWeight: "900", color: "#4E525C" }}>
                                            {` ${new Intl.DateTimeFormat("en-US", { weekday: "long" }).format((selectedBadge.streak.end_date + 60 * 60 * 24) * 1000)},
                                            ${new Intl.DateTimeFormat("en-US", { month: "long" }).format((selectedBadge.streak.end_date + 60 * 60 * 24) * 1000)}
                                            ${(new Date((selectedBadge.streak.end_date + 60 * 60 * 24) * 1000)).getDate()},
                                            ${(new Date((selectedBadge.streak.end_date + 60 * 60 * 24) * 1000)).getFullYear()}.`}
                                        </span>
                                    </div>
                                }
                            </div>
                        }
                        {!selectedBadge.is_locked && !selectedBadge.streak && selectedBadge.date_earned && isBadgeEarned(selectedBadge) &&
                            <>
                                <div className="badge-modal-check">
                                    <img style={{ filter: "invert(100%)" }} src={CheckIcon} alt="" />
                                </div>
                                <div className="badge-modal-congrats">
                                    {`You earned this badge on `}
                                    <span style={{ fontWeight: "900", color: "#4E525C" }}>
                                        {` ${new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(selectedBadge.date_earned * 1000)},
                                        ${new Intl.DateTimeFormat("en-US", { month: "long" }).format(selectedBadge.date_earned * 1000)}
                                        ${(new Date(selectedBadge.date_earned * 1000)).getDate()},
                                        ${(new Date(selectedBadge.date_earned * 1000)).getFullYear()}`}.
                                    </span>
                                </div>
                            </>
                        }
                        {!selectedBadge.is_locked && !selectedBadge.streak && selectedBadge.earn_latest && selectedBadge.earn_latest.date_earned && isBadgeEarned(selectedBadge) &&
                            <>
                                <div className="badge-modal-check">
                                    <img style={{ filter: "invert(100%)" }} src={CheckIcon} alt="" />
                                </div>
                                <div className="badge-modal-congrats">
                                    {`You earned this badge on `}
                                    <span style={{ fontWeight: "900", color: "#4E525C" }}>
                                        {` ${new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(new Date(selectedBadge.earn_latest.date_earned))},
                                        ${new Intl.DateTimeFormat("en-US", { month: "long" }).format(new Date(selectedBadge.earn_latest.date_earned))}
                                        ${(new Date(selectedBadge.earn_latest.date_earned)).getDate()},
                                        ${(new Date(selectedBadge.earn_latest.date_earned)).getFullYear()}`}.
                                    </span>
                                </div>
                            </>
                        }
                    </div>
                </div>
                {isBadgeEarned(selectedBadge) && <div className="badge-modal-share">
                    <div className="share-header">Your badge game is on point. Share it with the world.</div>
                    <div className="badge-modal-share-container">
                        <Link
                            to={{ pathname: `/badges/${selectedBadge.id}`, search: window.location.search }}
                            reloadDocument="false"
                            data-track="click"
                            data-id="nba:membership-hub:social"
                            data-section="badges"
                            data-content="CopyLink"
                            data-type="social"
                            className="share-button" title="Copy Link" onClick={(e) => shareOnSocial(e, "copy")}>
                            {linkCopied ?
                                <>
                                    <div className="icon-container link-copied">
                                        <img src={CheckIcon} alt="Link Copied" className="badge-modal-share-icon" />
                                    </div>
                                    <div className="site-name">Link Copied</div>
                                </>
                                :
                                <>
                                    <div className="icon-container">
                                        <img src={CopyLinkIcon} alt="Copy Link" className="badge-modal-share-icon" />
                                    </div>
                                    <div className="site-name">Copy Link</div>
                                </>
                            }
                        </Link>
                        <Link
                            to={{ pathname: `/badges/${selectedBadge.id}`, search: window.location.search }}
                            reloadDocument="false"
                            data-track="click"
                            data-id="nba:membership-hub:social"
                            data-section="badges"
                            data-content="Facebook"
                            data-type="social"
                            className="share-button" title="Share on Facebook" onClick={(e) => shareOnSocial(e, "facebook")}>
                            <div className="icon-container">
                                <img src={FbIcon} alt="Share on Facebook" className="badge-modal-share-icon" />
                            </div>
                            <div className="site-name">Facebook</div>
                        </Link>
                        <Link
                            to={{ pathname: `/badges/${selectedBadge.id}`, search: window.location.search }}
                            reloadDocument="false"
                            data-track="click"
                            data-id="nba:membership-hub:social"
                            data-section="badges"
                            data-content="Twitter"
                            data-type="social"
                            className="share-button" title="Share on Twitter" onClick={(e) => shareOnSocial(e, "twitter")}>
                            <div className="icon-container">
                                <img src={TwitterIcon} alt="Share on Twitter" className="badge-modal-share-icon" />
                            </div>
                            <div className="site-name">X (Twitter)</div>
                        </Link>
                    </div>
                </div>}
            </div>
        </div>
    )
};

export default BadgeModal;
